import React from 'react';
import ContentLoader from 'react-content-loader';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';

const styles = ({
  palette: {
    common: { white },
    divider,
  },
}: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      background: white,
      width: '100%',
      height: 95,
      borderBottom: `1px solid ${divider}`,
    },
    userInfo: {
      height: 180,
      width: 350,
      minWidth: 350, // min-width so layout wont get tiny in tiny screens.
    },
    headerActions: {
      height: 180,
      width: 200,
      minWidth: 200, // min-width so layout wont get tiny in tiny screens.
    },
  });

export interface ContentLoaderPatientHeaderProps extends WithStyles<typeof styles> {}

const ContentLoaderPatientHeader: React.FC<ContentLoaderPatientHeaderProps> = ({ classes, ...rest }) => (
  <div className={classes.root} {...rest}>
    <div className={classes.userInfo}>
      <ContentLoader width={400} height={200}>
        <circle cx="57" cy="48" r="30" />
        <rect x="100" y="43" rx="2" ry="2" width="140" height="10" />
        <rect x="100" y="61" rx="2" ry="2" width="220" height="10" />
        <rect x="100" y="18" rx="2" ry="2" width="100" height="13" />
      </ContentLoader>
    </div>
    <div className={classes.headerActions}>
      <ContentLoader width={150} height={200}>
        <circle cx="40" cy="25" r="13" />
        <circle cx="80" cy="25" r="13" />
        <circle cx="120" cy="25" r="13" />
      </ContentLoader>
    </div>
  </div>
);

export default withStyles(styles)(ContentLoaderPatientHeader);
